import graphql__4ea2488d955d265b285e from "./__generated__/NotificationSettingsForm_recipient.graphql.js";
import graphql__babf0db1ca75f466a4b6 from "./__generated__/NotificationSettingsForm_notificationCycles.graphql.js";import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import SelectField from "../Form/Field/SelectField";

const NotificationSettingsForm = props => {
  const notificationCycles = useFragment(
    NotificationSettingsForm_notificationCycles,
    props.notificationCycles
  );
  const recipient = useFragment(NotificationSettingsForm_recipient, props.recipient);
  const { notificationSettings } = recipient;

  const options = useMemo(
    () => notificationCycles.map(({ id, name }) => ({ value: id, label: name })),
    [notificationCycles]
  );

  return (
    <div className="notification-settings-form">
      {notificationSettings.map(({ category, cycle }) => (
        <SelectField
          key={category.id}
          fieldName={category.id}
          label={category.name}
          required
          schemaType="select"
          defaultValue={{ value: cycle.id }}
          options={options}
        />
      ))}
    </div>
  );
};

const NotificationSettingsForm_recipient = graphql__4ea2488d955d265b285e;

const NotificationSettingsForm_notificationCycles = graphql__babf0db1ca75f466a4b6;

export default NotificationSettingsForm;
